import React from 'react';
import { takeEvery, put, all } from 'redux-saga/effects';

import * as types from '../../actions/school-release-info/types';
import * as actions from '../../actions/school-release-info';

import apiFetcher from '../../tools/api-fetcher';
import handleError from '../../tools/error-helper';

import 'react-redux-toastr/';

function* getSchoolReleaseInfoData() {
  yield put(actions.setSchoolReleaseInfoLoading(true));

  try {
    const releaseInfo = yield apiFetcher
      .auth()
      .get(`release`);

    yield put(actions.setSchoolReleaseInfoData(releaseInfo.data));
  } catch (exception) {
    handleError(exception, 'Failed to load release info for the school user.');
  }

  yield put(actions.setSchoolReleaseInfoLoading(false));
}

function* setReleaseSeenByTheSchoolUser({ releaseId }) {
  try {
    yield apiFetcher
      .auth()
      .post(`release`, { latestSeenReleaseId: releaseId });
  } catch (exception) {
    handleError(exception, 'Failed to save latest seen release info.');
  }
}

export default function* schoolDashboardSaga() {
  yield all(
    [
      takeEvery(types.SCHOOL_RELEASE_INFO_GET_DATA, getSchoolReleaseInfoData),
      takeEvery(types.SCHOOL_RELEASE_INFO_SET_RELEASE_SEEN_BY_SCHOOL_USER, setReleaseSeenByTheSchoolUser)
    ]
  );
}


// WEBPACK FOOTER //
// ./src/sagas/school/school-release-info.js